<template>
  <div>
    <div class="PcDevice">
      <div class="contentBoxStatus">
        <p class="mb-2 text-center" style="font-size: 15px">
          Please upload the information for the following items to ensure the
          visitors understand your company, products, and services clearly
        </p>

        <div
          class="mb-4 text-center py-2"
          style="font-size: 15px; margin-right: 18%; margin-left: 18%"
        >
          <div class="d-flex justify-content-around">
            <div class="btn btn-info">
              <a :href="`profile?no=${RegNo}`">
                <div class="d-flex align-items-center">
                  <span v-if="BasicinformationStatus == 1" class="mr-2">
                    <i class="fas fa-check text-success"></i
                  ></span>
                  <span v-else class="mr-2">
                    <i class="fas fa-exclamation-circle text-secondary"></i
                  ></span>
                  <span style="color: black">Information </span>
                </div>
              </a>
            </div>
            <div class="btn btn-info" v-if="!LocalExh">
              <a :href="`Fascia?no=${RegNo}`">
                <div class="d-flex align-items-center">
                  <span v-if="FasciaStatus" class="mr-2">
                    <i class="fas fa-check text-success"></i
                  ></span>
                  <span v-else class="mr-2"
                    ><i class="fas fa-exclamation-circle text-secondary"></i
                  ></span>
                  <span style="color: black">Fascia </span>
                </div>
              </a>
            </div>
            <div class="btn btn-info" v-if="!LocalExh">
              <a :href="`Badge?no=${RegNo}`">
                <div class="d-flex align-items-center">
                  <span v-if="BadgeStatus" class="mr-2"
                    ><i class="fas fa-check text-success"></i
                  ></span>
                  <span v-else class="mr-2"
                    ><i class="fas fa-exclamation-circle text-secondary"></i
                  ></span>
                  <span style="color: black">Badge </span>
                </div>
              </a>
            </div>
            <div class="btn btn-info">
              <a :href="`product?no=${RegNo}`">
                <div class="d-flex align-items-center">
                  <span v-if="ProductStatus !== 0" class="mr-2"
                    ><i class="fas fa-check text-success"></i
                  ></span>
                  <span v-else class="mr-2"
                    ><i class="fas fa-exclamation-circle text-secondary"></i
                  ></span>
                  <span class="border-dark text-dark">Products </span>
                </div>
              </a>
            </div>

            <div class="btn btn-info" v-if="LocalExh">
              <a :href="`Boothevent?no=${RegNo}`">
                <div class="d-flex align-items-center">
                  <span v-if="BoothEventStatus !== 0" class="mr-2"
                    ><i class="fas fa-check text-success"></i
                  ></span>
                  <span v-else class="mr-2"
                    ><i class="fas fa-exclamation-circle text-secondary"></i
                  ></span>
                  <span class="border-dark text-dark">Booth Events </span>
                </div>
              </a>
            </div>

            <div class="btn btn-info">
              <a :href="`news?no=${RegNo}`">
                <div class="d-flex align-items-center">
                  <span v-if="PressReleaseStatus !== 0" class="mr-2"
                    ><i class="fas fa-check text-success"></i
                  ></span>
                  <span v-else class="mr-2"
                    ><i class="fas fa-exclamation-circle text-secondary"></i
                  ></span>
                  <span style="color: black">Press Release </span>
                </div>
              </a>
            </div>
            <div class="btn btn-info">
              <a :href="`video?no=${RegNo}`">
                <div class="d-flex align-items-center">
                  <span v-if="VideoStatus !== 0" class="mr-2"
                    ><i class="fas fa-check text-success"></i
                  ></span>
                  <span v-else class="mr-2"
                    ><i class="fas fa-exclamation-circle text-secondary"></i
                  ></span>
                  <span style="color: black">Video </span>
                </div>
              </a>
            </div>

            <span v-if="showOnlineStatus">
              <a :href="`onlineExpo?no=${RegNo}`">
                <div class="d-flex align-items-center">
                  <span v-if="OnlineExpolayoutStatus == 1" class="mr-2"
                    ><i class="fas fa-check text-success"></i
                  ></span>
                  <span v-else class="mr-2"
                    ><i class="fas fa-exclamation-circle text-secondary"></i
                  ></span>
                  <span style="color: black">Online Expo Settings </span>
                </div>
              </a>
            </span>
          </div>
        </div>
      </div>
      <div class="my-3"></div>
    </div>

    <div class="MbDevice container contentBoxStatus">
      <div class="contentBoxStatus">
        <p class="mb-3 text-center" style="font-size: 12px">
          Please upload the information for the following items to ensure the
          visitors understand your company, products, and services clearly
        </p>

        <div
          class="mb-4 border text-center py-2"
          style="font-size: 12px; border-radius: 10px"
        >
          <div class="d-flex justify-content-around">
            <div>
              <a :href="`profile?no=${RegNo}`">
                <div class="row justify-content-center align-items-center">
                  <div class="col-md-6">
                    <span v-if="BasicinformationStatus == 1"
                      ><i class="fas fa-check text-success"></i
                    ></span>
                    <span v-else
                      ><i class="fas fa-exclamation-circle text-secondary"></i
                    ></span>
                  </div>
                </div>
                <div class="col-md-6">
                  <span style="color: black">Information</span>
                </div>
              </a>
            </div>
            <div v-if="!LocalExh">
              <a :href="`Fascia?no=${RegNo}`">
                <div class="row justify-content-center align-items-center">
                  <div class="col-md-6">
                    <span v-if="FasciaStatus"
                      ><i class="fas fa-check text-success"></i
                    ></span>
                    <span v-else
                      ><i class="fas fa-exclamation-circle text-secondary"></i
                    ></span>
                  </div>
                  <div class="col-md-6">
                    <span style="color: black">Fascia</span>
                  </div>
                </div>
              </a>
            </div>

            <div v-if="!LocalExh">
              <a :href="`Badge?no=${RegNo}`">
                <div class="row justify-content-center align-items-center">
                  <div class="col-md-6">
                    <span v-if="BadgeStatus"
                      ><i class="fas fa-check text-success"></i
                    ></span>
                    <span v-else
                      ><i class="fas fa-exclamation-circle text-secondary"></i
                    ></span>
                  </div>
                  <div class="col-md-6">
                    <span style="color: black">Badge</span>
                  </div>
                </div>
              </a>
            </div>
            <div>
              <a :href="`product?no=${RegNo}`">
                <div class="row justify-content-center align-items-center">
                  <div class="col-md-6">
                    <span v-if="ProductStatus !== 0"
                      ><i class="fas fa-check text-success"></i
                    ></span>
                    <span v-else
                      ><i class="fas fa-exclamation-circle text-secondary"></i
                    ></span>
                  </div>
                  <div class="col-md-6">
                    <span class="border-dark text-dark">Products</span>
                  </div>
                </div>
              </a>
            </div>

            <div v-if="LocalExh">
              <a :href="`Boothevent?no=${RegNo}`">
                <div class="row justify-content-center align-items-center">
                  <div class="col-md-6">
                    <span v-if="BoothEventStatus !== 0"
                      ><i class="fas fa-check text-success"></i
                    ></span>
                    <span v-else
                      ><i class="fas fa-exclamation-circle text-secondary"></i
                    ></span>
                  </div>
                  <div class="col-md-6">
                    <span class="border-dark text-dark">Events</span>
                  </div>
                </div>
              </a>
            </div>

            <div>
              <a :href="`news?no=${RegNo}`">
                <div class="row justify-content-center align-items-center">
                  <div class="col-md-6">
                    <span v-if="PressReleaseStatus !== 0"
                      ><i class="fas fa-check text-success"></i
                    ></span>
                    <span v-else
                      ><i class="fas fa-exclamation-circle text-secondary"></i
                    ></span>
                  </div>
                  <div class="col-md-6">
                    <span style="color: black">Press Release</span>
                  </div>
                </div>
              </a>
            </div>

            <div>
              <a :href="`video?no=${RegNo}`">
                <div class="row justify-content-center align-items-center">
                  <div class="col-md-6">
                    <span v-if="VideoStatus !== 0"
                      ><i class="fas fa-check text-success"></i
                    ></span>
                    <span v-else
                      ><i class="fas fa-exclamation-circle text-secondary"></i
                    ></span>
                  </div>
                  <div class="col-md-6">
                    <span style="color: black">Video</span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      ExhibitionCode: "",
      RegNo: "",
      //判斷各頁狀態儀表版值
      OnlineExpolayoutStatus: "",
      PressReleaseStatus: "",
      VideoStatus: "",
      ProductStatus: "",
      BasicinformationStatus: "",
      FasciaStatus: false,
      BadgeStatus: false,
      LocalExh: true,
      BoothEventStatus: "",
    };
  },

  methods: {},

  created() {
    const vm = this;

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];

    let nowPage = location.href;
    vm.getUrl = nowPage.split("ExhibitorServiceTW")[1];

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=en`
      )
      .then((response) => {
        if (response.data.Code == 200) {
          let ExpoLocation = response.data.Data.ExpoLocation;

          if (ExpoLocation === "T" || ExpoLocation === null) {
            vm.LocalExh = true;
          } else {
            vm.LocalExh = false;
          }
        }
      });

    //儀錶板狀態

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`)
      .then((response) => {
        vm.HasOnlineExpo = response.data.Data.Virtual;

        //取得是否填寫狀態盤的值

        vm.OnlineExpolayoutStatus = response.data.Data.OnlineExpolayoutStatus;
        vm.PressReleaseStatus = response.data.Data.PressReleaseStatus;
        vm.VideoStatus = response.data.Data.VideoStatus;
        vm.ProductStatus = response.data.Data.ProductStatus;
        vm.BasicinformationStatus = response.data.Data.BasicinformationStatus;
        vm.BadgeStatus = response.data.Data.HasBadge;
        vm.FasciaStatus = response.data.Data.HasFascia;
        vm.BoothEventStatus = response.data.Data.BoothEventStatus;
      });

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/RegNoCheck/${vm.RegNo}?lang=tw`
      )
      .then((response) => {
        // console.log(response.data.Data)

        vm.ExhibitionCode = response.data.Data.ExhibitionCode;
      });
  },
};
</script>

<style lang="scss">
// .  {
//   background-image: url("../assets/images/tickGray.svg");
//   width: 18px;
//   height: 18px;
//   display: inline-block;
//   background-repeat: no-repeat;
//   background-position: left center;
//   background-size: auto 100%;
//   padding-left: 20px;
// }

// .  {
//   background-image: url("../assets/images/tick.svg");
//   width: 18px;
//   height: 18px;
//   display: inline-block;
//   background-repeat: no-repeat;
//   background-position: left center;
//   background-size: auto 100%;
//   padding-left: 20px;
// }

.btn-info {
  color: #fff;
  background-color: #f7faff;
  border-color: #dcdeff;
}

.btn-info:hover {
  background-color: #f7faff;
  border-color: #dcdeff;
  color: #000000;
}

.fa,
.fas {
  font-weight: 900;
  color: #737373;
  font-size: 13px;
}
</style>
